import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { JSONAPI_URLS, OUTSIDE_API } from '../../../consts/endpoints';
import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, GET_EXTERNAL_NO_RANGES } from './types';
import { actions as loaderReducActions } from '../../../partials/loader/reducers';
import urlCreator from '../../../utils/urlCreator';
import { getData } from '../../../utils/http';
import createNetworkOptions from './createNetworkOptions';
import mapMitelData from './mapMitelData';
import { isArray, isDefined, isString } from '../../../utils/isDefined';
import getFullTableData from '../../../utils/getFullTableData';
import orderBy from 'lodash.orderby';

export function getExternalNoRanges({
  id,
  getServiceOperator,
  getConnectRanges,
  connectClientId
}) {
  return {
    type: sagaActions[GET_EXTERNAL_NO_RANGES],
    id,
    getServiceOperator,
    getConnectRanges,
    connectClientId
  };
}

export function* fetchExternalNoRanges({
  id,
  getConnectRanges = false,
  getServiceOperator = false,
  connectClientId
}) {
  yield put(loaderReducActions.startSpinLoader());
  const QUERY_PARAMS = yield call(mapQueryParams, {
    id,
    getServiceOperator,
    getConnectRanges
  });

  const mitelQueryParam = {
    include_usage: true,
    paginate: false
  };

  let externalNo = yield call(
    getFullTableData,
    JSONAPI_URLS.EXTERNAL_NO_RANGES,
    QUERY_PARAMS
  );

  const simCardsQueryParams = {
    include: ['owner', 'primary_card', 'primary_card.owner'],
    fields: {
      sim_cards: ['card_type', 'msisdn', 'description', 'active'],
      users: 'name'
    },
    filter: { client_id: isDefined(id) ? { eq: id } : { gt: 0 } }
  };

  const simCards = yield call(
    getFullTableData,
    JSONAPI_URLS.SIM_CARDS,
    simCardsQueryParams
  );

  let connectRanges = [];

  try {
    const response =
      isDefined(connectClientId) && isDefined(id)
        ? yield call(
            getData,
            urlCreator(
              `${OUTSIDE_API.CLIENTS}/${connectClientId}/number_ranges`,
              mitelQueryParam
            )
          )
        : [];

    const mappedNumberRanges = yield call(mapMitelData, {
      response,
      externalNo,
      simCards
    });

    externalNo = mappedNumberRanges;
    connectRanges = mapConnetRanges(response, externalNo);
  } catch {}

  const networkOptions = yield call(createNetworkOptions, externalNo);

  yield put(
    reduxActions.setExternalNoRanges(externalNo, networkOptions, connectRanges)
  );
  yield put(loaderReducActions.stopSpinLoader());
}

function* watchGetExternalNoRanges() {
  yield takeLatest(sagaActions[GET_EXTERNAL_NO_RANGES], fetchExternalNoRanges);
}

export default watchGetExternalNoRanges();

export function mapQueryParams({ id, getServiceOperator, getConnectRanges }) {
  let external_number_ranges = [];

  if (getServiceOperator) {
    external_number_ranges = [...external_number_ranges, 'service_operator'];
  }
  if (getConnectRanges) {
    external_number_ranges = [
      'connect30_number_ranges',
      ...external_number_ranges
    ];
  }
  return {
    include: ['client', 'provider', 'address', 'phone_book_registrations'],
    fields: { client: ['name', 'csbc_routing'] },
    extra_fields: {
      external_number_ranges
    },
    filter: { client_id: isDefined(id) ? { eq: id } : { gt: 0 } }
  };
}

const mapConnetRanges = (ranges, numberRanges) => {
  if (!isArray(ranges)) {
    return [];
  }

  const filtered = ranges.filter(
    range =>
      isString(range.range_from) &&
      range.range_from.replace('+', '').trim().length >= 8
  );

  const mappedRanges = filtered.map((el, i) => {
    const unassigned = [...el.unassigned_numbers].map(number => {
      const founded = findRange({ numberRanges, number });
      return { number, founded };
    });

    const assigned = [...el.assigned_numbers].map(number => {
      const founded = findRange({ numberRanges, number: number.number });
      return { ...number, founded };
    });

    return {
      ...el,
      range_from: el.range_from.replace('+', '').trim(),
      range_up_to_incl: el.range_up_to_incl.replace('+', '').trim(),
      all: [...assigned, ...unassigned],
      assigned,
      unassigned,
      id: i
    };
  });

  return orderBy(mappedRanges, 'range_from');
};

const findRange = ({ numberRanges, number }) => {
  return numberRanges.find(
    range => number >= range.range_from && number <= range.range_up_to_incl
  );
};
